import { render } from "./user-dep.vue?vue&type=template&id=b1c581e8&scoped=true"
import script from "./user-dep.vue?vue&type=script&lang=js"
export * from "./user-dep.vue?vue&type=script&lang=js"

import "./user-dep.vue?vue&type=style&index=0&id=b1c581e8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c581e8"]])

export default __exports__